import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ArrowLeft, TrendingUp, Package } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL || ''}/api`;

export default function MobileSODetailPage() {
  const { soId } = useParams();
  const navigate = useNavigate();
  const [so, setSo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/warehouse/sales-orders/${soId}`).then(r => setSo(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, [soId]);

  if (loading) return <div className="mobile-page"><div className="mobile-loading"><div className="mobile-spinner" /></div></div>;
  if (!so) return <div className="mobile-page"><button className="mobile-back-btn" onClick={() => navigate(-1)}><ArrowLeft size={18} /> Back</button><div className="mobile-empty-state"><p>SO not found</p></div></div>;

  const lineItems = so.line_items || [];

  return (
    <div className="mobile-page">
      <button className="mobile-back-btn" onClick={() => navigate('/mobile/sales-orders')}><ArrowLeft size={18} /> Sales Orders</button>
      <div className="mobile-detail-section" style={{ textAlign: 'center', paddingTop: 20, paddingBottom: 20 }}>
        <div style={{ width: 48, height: 48, borderRadius: 12, background: '#34c759', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 10px', color: 'white' }}><TrendingUp size={24} /></div>
        <div style={{ fontSize: 20, fontWeight: 700, color: '#1c1c1e' }}>{so.so_number}</div>
        <div style={{ fontSize: 14, color: '#8e8e93', marginTop: 4 }}>{so.customer_name || 'N/A'}</div>
        <span className={`mobile-status-badge ${so.status === 'shipped' ? 'in_production' : so.status === 'confirmed' ? 'staged' : 'scheduled'}`} style={{ marginTop: 8 }}>{so.status || 'open'}</span>
      </div>
      <div className="mobile-detail-section">
        <div className="mobile-detail-section-title">Details</div>
        {so.customer_name && <div className="mobile-detail-row"><span className="mobile-detail-label">Customer</span><span className="mobile-detail-value">{so.customer_name}</span></div>}
        {so.order_date && <div className="mobile-detail-row"><span className="mobile-detail-label">Order Date</span><span className="mobile-detail-value">{so.order_date}</span></div>}
        {so.ship_date && <div className="mobile-detail-row"><span className="mobile-detail-label">Ship Date</span><span className="mobile-detail-value">{so.ship_date}</span></div>}
        {so.delivery_date && <div className="mobile-detail-row"><span className="mobile-detail-label">Delivery</span><span className="mobile-detail-value">{so.delivery_date}</span></div>}
        <div className="mobile-detail-row"><span className="mobile-detail-label">Items</span><span className="mobile-detail-value">{lineItems.length}</span></div>
      </div>
      {lineItems.length > 0 && (
        <div className="mobile-detail-section">
          <div className="mobile-detail-section-title">Line Items ({lineItems.length})</div>
          {lineItems.map((li, i) => (
            <div key={i} className="mobile-detail-row">
              <span className="mobile-detail-label"><Package size={12} style={{ display: 'inline', verticalAlign: -1, marginRight: 4 }} />{li.item_name || `Item ${i+1}`}</span>
              <span className="mobile-detail-value">{li.quantity_ordered || li.quantity || 0} {li.unit || ''}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
